import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageBoxDialog } from '../message-box/message-box.component';
import { MatDialog } from '@angular/material';
import { Ng2DeviceService } from 'ng2-device-detector';
import { ConfigurationService } from '../services/configuration.service';
import { RequisitionService } from '../services/requisition.service';
import { ContractRequisition } from '../models/contractRequisition';

@Component({
  selector: 'app-create-requisition',
  templateUrl: './create-requisition.component.html',
  styleUrls: ['./create-requisition.component.css']
})
export class CreateRequisitionComponent implements OnInit {

  constructor(
  ) { }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// /Users/everis/code/Dj/front.staff/src/app/create-requisition/create-requisition.component.ts